const TokenKey = 'Admin-H5-Token'

const ExpiresInKey = 'Admin-H5-Expires-In'

const Codes = 'Admin-H5-Codes'

export function getToken() {
  var token = localStorage.getItem(TokenKey);

  // 如果token长度大于100则删除
  if(token && token.length > 100){
    localStorage.removeItem(TokenKey);
    token = null;
  }

  if (token) {
    return localStorage.getItem(TokenKey);
  }else{
      token = getQueryVariable("token");
    if(token){
      localStorage.setItem(TokenKey, token);
    }
    return token;
  }
  // return sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
}

export function getExpiresIn() {
  return localStorage.getItem(ExpiresInKey) || -1
}

export function setExpiresIn(time) {
  return localStorage.setItem(ExpiresInKey, time)
}

export function removeExpiresIn() {
  return sessionStorage.removeItem(ExpiresInKey)
}

export function getCodeList() {
  return sessionStorage.getItem(Codes)
}

export function setCodeList(code) {
  return sessionStorage.setItem(Codes, code)
}
function getQueryVariable(variable)
{
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if(pair[0] == variable){return pair[1];}
  }
  return null;
}
